






































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import IntoLogisticsCheckResult from '@/store/entities/Into-logistics-checkresult';
    import appconst from '@/lib/appconst';
    import QRcode from 'qrcodejs2'
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)

    class EditLogistics {
        id: number;
        warehouseId: number;
        shipment: string;
        userCode: string;
        processTime?: Date;
        receiveStatus: number;
        imageGuid: string;
        reMark: string;
        shelfNumber: string;
        isConfirm: boolean;
        goodsImageGuid: string;
        //orderType: number;
        
    }

   @Component({
        name:"intoLogistics",
    })
    export default class CreateLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        logistics: EditLogistics = new EditLogistics();
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        isDisplay: string = '';
        imgUrl: string = '';
        selectDate: string = "";
        selectTime: string = "";
        oldReceiveStatus: number;
        isReadOnly = false;
        imgUploadUrl: string = '';
       goodsimgUrl: string = '';
       //waerhouseOrderType: number = null;
       shelfNumberInfo: string = '';
       checkLoding = false;
       isNative: boolean = false;
       checkResult: IntoLogisticsCheckResult = null;
       titleList: Array<string> = [];

        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        created() {
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
            this.getCity();
          
        }

        handleSuccess(res, file) {
            if (res.success) {
                this.logistics.imageGuid = res.result;
                var data = { imageGuid: this.logistics.imageGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.imgUrl = data.url;
            }
       }
       async NumberClick(ev) {
           if (ev.code == "ArrowLeft") {
               this.checkExpress();
           }
           else if (ev.code == "ArrowRight") {
               this.signFor();
           }
       }

       setQrCode(val: string) {

           let qrcode = new QRcode('exqrcode', {
               width: 150,
               height: 150, // 高度
               text: window.location.origin + "/#/takephone/logisticsphoto?shipment=" + val, // 二维码内容
           });
           //document.getElementById('qrcode').innerHTML = "";
       }


       async checkExpress() {
           document.getElementById('exqrcode').innerHTML = "";
           var shipMent = this.logistics.shipment;
           if (!shipMent && shipMent.length == 0) {
               this.$Message.error('检查的快递单号不能为空。');
               return;
           }
           if (!this.logistics.warehouseId) {
               this.$Message.error('仓库不能为空。');
               return;
           }
           setTimeout(() => {
               this.setQrCode(shipMent);
           }, 500);
           var data = { Shipment: shipMent, WarehouseId: this.logistics.warehouseId };
                        this.clearData();
           this.logistics.shipment = data.Shipment;
           this.logistics.warehouseId = data.WarehouseId;
           this.checkLoding = true;
           this.titleList = [];
           this.checkResult= await this.$store.dispatch({
                        type: 'backlogistics/getIntoLogisticsCheckResult',
                        data: this.logistics
           }).finally(() => {
               this.checkLoding = false;
           });
           if (this.checkResult.isNative) {
               this.isNative = true;
               //this.waerhouseOrderType = 1;
           }
           else {
               //this.waerhouseOrderType = 0;
               this.isNative = false;
           }
           this.checkResult.shipment = data.Shipment;
           this.logistics.userCode = this.checkResult.userCode;
           this.logistics.isConfirm = true;
           this.logistics.shelfNumber = this.checkResult.shelfNumber;
           if (this.isNative) {
               
               this.titleList.push("本土");
               if (this.checkResult.isRemind) {
                   this.$Modal.warning({ title: "提示", content: "用户积分不足300！" });
                   //this.titleList.push("用户积分不足300");
               }
           }
           if (this.checkResult.isReject) {
               this.logistics.shelfNumber = "拒收";
               this.titleList.push("拒收");
           }
           if (this.checkResult.isHeadless) {
               this.titleList.push("无头件");
           } else {
               if (this.checkResult.haveOtherWaitPackagesOrder) {
                   this.titleList.push("关联多订单");
               }
               if (this.checkResult.isReject) {
                   this.titleList.push("无法打包" + (this.checkResult.isCreateOrder?"（多包裹未到齐）":"（未创建仓库订单）"));
               } else if (this.checkResult.isPack) {
                   this.titleList.push("可以打包");
               } else {
                    this.titleList.push("无法打包"+ (this.checkResult.isCreateOrder?"（多包裹未到齐）":"（未创建仓库订单）"));
               }
           }

           if (this.checkResult.isReject) {
                    this.shelfNumberInfo = "拒收快递，建议输入货架号";
               }
           else if (this.checkResult.isHeadless) {
                   this.shelfNumberInfo = "无头件，建议输入货架号";
               }
           else if (!this.checkResult.isPack) {
                   this.shelfNumberInfo = "无法打包，建议输入货架号";
               }
           else if (this.checkResult.isPack && this.checkResult.haveOtherWaitPackagesOrder) {
                   this.shelfNumberInfo = "可以打包，但是还有其他关联订单；建议输入货架号";
             }
           else if (this.checkResult.isPack && !this.checkResult.haveOtherWaitPackagesOrder) {
                    this.shelfNumberInfo = "关联订单都可以打包，无需输入货架号";
             }
           else {
                this.shelfNumberInfo = '';
           }
           if (this.shelfNumberInfo.indexOf("可以打包") != -1) {
               this.signFor();
           }
           //if (this.waerhouseOrderType == null) {
           //    this.$Modal.info("此快递没有关联订单，需要手动选择跨境还是本土");
           //}
           //else {
           //    this.logistics.orderType = this.waerhouseOrderType;
           //}
           
        }
        handleError(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }

       copyShipment() {
           if (!this.logistics.shipment || this.logistics.shipment.length < 0) {
                 this.$Message.error('快递单号为空，不能复制。');
           }
           this.copyInfo(this.logistics.shipment);
       }

       copyInfo(data) {
            var _this = this;
            this.$copyText(data).then(function (e) {
                _this.$Message.success("复制成功");
            }, function (e) {
                _this.$Message.error("复制失败");
            });
        }

        setImage() {
            if (this.logistics.goodsImageGuid && this.logistics.goodsImageGuid.length > 1) {
                var datas = { goodsImageGuid: this.logistics.goodsImageGuid, urls: null };
                this.$store.commit('backlogistics/getGoodsImgUrl', datas);
                this.goodsimgUrl = datas.urls;
            } else {
                this.goodsimgUrl = null;
            }
        }

        handleSuccessGoods(res, file) {
            if (res.success) {
                this.logistics.goodsImageGuid = res.result;
                this.setImage();
            }
        }
        handleErrorGoods(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }


       signFor() {
           if (!this.checkResult || !this.checkResult.shipment) {
               this.$Modal.error({ title: "错误", content: "未检查快递信息，不允许入库！" });
               return;
           }
           if (this.checkResult.shipment != this.logistics.shipment) {
               this.$Modal.error({ title: "错误", content: "检查的快递单号：" + this.checkResult.shipment + "与现在入库的快递单号:" + this.logistics.shipment + "不一致。" });
               return;
           }
           //if (this.waerhouseOrderType == null) {
           //    this.$Modal.info("此快递没有关联订单，需要手动选择跨境还是本土");
           //}
          
            this.logistics.receiveStatus = 1;
            var _this = this;
            if (this.checkResult.isHeadless && (!this.logistics.imageGuid || !this.logistics.goodsImageGuid)) {
                _this.$Modal.confirm({
                    title: "图片不完整", content: "无头件但是没有上传图片,是否继续入库？", width: 800, onOk: async () => {
                        setTimeout(() => {
                            _this.judgeShipment();
                        }, 500);
                    }
                });
            } else {
                 _this.judgeShipment();
            }

       }
       judgeShipment() {
           var _this = this;
           if (!this.logistics.shelfNumber || this.logistics.shelfNumber.length == 0) {
               var info: string = null;
               if (this.checkResult.isReject) {
                    info = "拒收快递，建议输入货架号";
               }
               else if (this.checkResult.isHeadless) {
                   info = "无头件，建议输入货架号";
               }
               else if (!this.checkResult.isPack) {
                   info = "无法打包，建议输入货架号";
               }
               else if (this.checkResult.isPack && this.checkResult.haveOtherWaitPackagesOrder) {
                   info = "可以打包，但是还有其他关联订单未到齐；建议输入货架号";
               }
               if (info) {
                   _this.$Modal.confirm({
                       title: "货架号为空", content: info + ",是否继续入库？", width: 800, onOk: async () => {
                           setTimeout(() => {
                               _this.save();
                           }, 500);
                       }
                   });
               }
               else {
                   this.save();
               }

           } else {
                         this.save();
           }
       }

       @Watch('$route.params.JumpPage')
       JumpPageChange() {
           if (this.$route.params.JumpPage) {
               var data: any = document.querySelector('input[name="shipmentId"]');
               data.focus();
           }
    

       }
        
       save() {
            (this.$refs.logisticsCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    if (!this.selectDate || this.selectDate.length == 0) {
                        var anyDate: any = this.selectDate;
                        this.logistics.processTime = anyDate;
                    }
                    this.logistics.shipment = this.logistics.shipment.trim();
                    await this.$store.dispatch({
                        type: 'backlogistics/updateLogistics',
                        data: this.logistics
                    });
                    if (this.checkResult.isPack && !this.checkResult.isReject) {
                        this.copyInfo(this.logistics.shipment);
                        //this.$Modal.success({ title: "快递入库成功", content: "快递入库成功，已帮你复制好快递单号，即将跳转订单管理列表！" });
                        this.$Message.success("快递入库成功");
                        var shipment = this.logistics.shipment;
                        if (this.isNative) {
                            this.$router.push({ name: 'backmainlandOrderList', params: { inputNativeShipment: shipment } });
                        }
                        else {
                            this.$router.push({ name: 'backOrderList', params: { inputShipment: shipment } });
                        }
                       
                        this.clearData();
                    } else {
                        this.clearData();
                        //this.$Modal.success({title:"快递入库成功",content:"快递入库成功！"});
                        this.$Message.success("快递入库成功");
                    }

                }
            })
       }

       clearData() {
           (this.$refs.logisticsCreateForm as any).resetFields();
           this.logistics.goodsImageGuid = null;
           this.logistics.imageGuid = null;
            this.goodsimgUrl =null;
            this.imgUrl =null;
            if (this.warehouseInfoList.length > 0) {
                this.logistics.warehouseId = this.warehouseInfoList[0].id;
            }
           this.checkResult = null;
       }

        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.logistics.warehouseId = this.warehouseInfoList[0].id;
            }
        }
       async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
           }
           var data: any = this.$refs.inputshipment;
           data.focus();
        }
        cancel() {
            (this.$refs.logisticsCreateForm as any).resetFields();
        }

        logisticsRule = {
            warehouseId: [
                    { required: true, message: '仓库不能为空', trigger: 'change',type:'number' }
            ],
            shipment: [
                { required: true, max: 30, message: '快递单号不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            userCode: [
                { required: true, max: 30, message: '用户编码不能为空，且长度必须小于30', trigger: 'blur' }
            ],
            reMark: [
                { max: 500, message: '长度不能大于500', trigger: 'blur' }
            ]
        };

    }
